export const FETCH_CRMDOCUMENTTYPES_BEGIN="FETCH_CRMDOCUMENTTYPES_BEGIN";
export const FETCH_CRMDOCUMENTTYPES_SUCCESS="FETCH_CRMDOCUMENTTYPES_SUCCESS";
export const FETCH_CRMDOCUMENTTYPES_FAILURE="FETCH_CRMDOCUMENTTYPES_FAILURE";